import { HEX_3D526B, HEX_646A7E, HEX_CED7E2, HEX_E2E5EB, HEX_ECF4FF } from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const Fill = defineColor([HEX_ECF4FF, HEX_3D526B]);
export const Border = defineColor([HEX_CED7E2, HEX_3D526B]);
export const Text = defineColor([HEX_646A7E, HEX_E2E5EB]);
